<template>
  <MDBRow v-if="extendedOnlineTrainigs()">
    <MDBCol cols="12" lg="6" xl="4" class="mb-4" v-for="(training, i) in trainings" :key="i"
      :class="`${training.show ? '' : 'd-none'}`">
      <Card :data="training" :linkText="$t('global.buttons.discover')" />
    </MDBCol>
  </MDBRow>
</template>

<script setup>
import Card from "@/components/General/Card/index.vue";
import { MDBRow, MDBCol } from "mdb-vue-ui-kit";
import { computed } from "vue";
import { useItemsConditions } from '@/composables/useItemsConditions'
import { useTenantConfig } from "@/composables/useTenantConfig";
import { showExtendedOnlineTrainings } from "@/composables/useProfileFieldCheck";
const { getContext } = useItemsConditions()
const context = computed(() => getContext())
import { useI18n } from "vue-i18n";
const { t } = useI18n() // Import the translation function from i18n
const { tenantConfig } = useTenantConfig();
const { extendedOnlineTrainigs } = showExtendedOnlineTrainings(tenantConfig);

const trainings = computed(() => [
  {
    name: t("trainings.online.categories.general.title"),
    link: { name: "onlineTrainingCategoryType", params: { id: "general" } },
    description: t("trainings.online.categories.general.description"),
    image: require("@/assets/img/online_trainings/general.png"),
    show: context.value.canSeeOnlineTraining,
  },
  {
    name: t("trainings.online.categories.product.title"),
    link: { name: "onlineTrainingCategoryType", params: { id: "product" } },
    description: t("trainings.online.categories.product.description"),
    image: require("@/assets/img/online_trainings/product.png"),
    show: context.value.canSeeOnlineTraining,
  },
]);
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";
</style>
